var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcAlertSuccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "szoy3dwfxa",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9b9b9b"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2470"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Ellipse 92",
    d: "M48.5 5a43.513 43.513 0 0 0-16.931 83.584A43.513 43.513 0 0 0 65.431 8.416 43.223 43.223 0 0 0 48.5 5m0-5A48.5 48.5 0 1 1 0 48.5 48.5 48.5 0 0 1 48.5 0z",
    style: {
      fill: "url(#szoy3dwfxa)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 418",
    d: "M8196.022-19627.445a2.5 2.5 0 0 1-1.762-.727l-17.334-17.215a2.5 2.5 0 0 1-.012-3.535 2.5 2.5 0 0 1 3.536-.012l15.327 15.221 27.1-35a2.5 2.5 0 0 1 3.507-.445 2.5 2.5 0 0 1 .446 3.508l-28.83 37.236a2.5 2.5 0 0 1-1.814.963c-.055.004-.11.006-.164.006z",
    transform: "translate(-8154.189 19697.322)",
    style: {
      fill: "url(#szoy3dwfxa)"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcAlertSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-alertSuccess.75e229cbd7ed21bf6773aece82f50405.svg";